module.exports = __webpack_public_path__ + "assets/img/icon_user19.e1d517ea.png";